import React from 'react';
import { Icon } from '../../../../../../components';
import { CourseTitleContainer } from './styled';
import TextHelper from '@/core/helpers/TextHelper';

interface IProps {
  title: string;
  styleTitle?: React.CSSProperties;
  catalogNumber: string;
  subtitle?: string;
  show: boolean;
  finalGrade?: string;
}

const CourseTitle = (props: IProps) => {
  const { title, styleTitle, catalogNumber, subtitle, show, finalGrade } =
    props;

  const titleFormatted = () =>
    `${TextHelper.fixRomans(TextHelper.capitalize(title, false, true))}${
      catalogNumber
        ? ` (${catalogNumber.charAt(0)}${catalogNumber.substring(6)})`
        : ''
    }`;

  return (
    <CourseTitleContainer>
      <div style={styleTitle}>
        {titleFormatted()}
        <p>
          {subtitle}
          {finalGrade && Number(finalGrade) > 0 && (
            <span>
              {' '}
              | Promedio: <span>{finalGrade}</span>
            </span>
          )}
        </p>
      </div>
      <button type="button">
        <Icon name={show ? 'chevron-up' : 'chevron-down'} size={24} />
      </button>
    </CourseTitleContainer>
  );
};

export default CourseTitle;
